import {RoleType} from "../../app/user-reduser";
import {PasswordChangeForm} from "../../ui/passwordChangeForm.tsx/PasswordChangeForm";

// Role
export const ROLE_TEACHER: RoleType = 'teacher';
export const ROLE_STUDENT: RoleType = 'student';
export const ROLE_HR: RoleType = 'hr';
export const ROLE_DEMO_STUDENT: RoleType = 'student-demo';




// Personal profile

export const BIRTHDATE = "Дата рождения";
export const EMAIL = "Email";
export const MOBILE_PHONE = "Мобильный телефон";
export const ADDITIONAL_PHONE = "Дополнительный телефон";
export const TIME_ZONE = "Временная зона";
export const CURRENT_DATE_TIME = "Текущая дата и время";
export const COUNTRY = "Страна";
export const ADDRESS = "Адрес";
export const PAYMENT_CURRENCY = "Валюта платежей";
export const SOCIAL_MEDIA = "Социальные сети";
export const REMINDERS = "Напоминания";


// Student's personal account
export const WELCOME_MESSAGE = "Добро пожаловать";
export const REMAINING_PAID_LESSONS = "Остаток оплаченных занятий";
export const BANK_TRANSFERS_TITLE = "Банковские переводы и платежи";
export const ALL_TRANSFERS_PAYMENTS = "Все переводы и платежи";
export const LESSON_TITLE = "Занятия";
export const MY_LEVEL = "Мой уровень";
export const HOME_WORK = "Домашнее задание";
export const LAST_SLICE = "Последний срез";
export const SERVICE_ACTS = "Акты оказанных услуг";
export const ALL_ACTS = "Все акты";


// Teacher's personal account

export const GROUPS = "Группы";
export const ALL_GROUPS = "Все группы";
export const PAST_LESSONS = "Прошедшие занятия";
export const NEW_STUDENTS = "Новые студенты";
export const TESTS = "Тесты";
export const ALL_TESTS = "Все тесты";


// Login

export const PASSWORD_RECOVERY_TEXT = "Восстановить пароль";
export const REGISTER_TEXT = "Регистрация";
export const LOGIN_TEXT = "Вход";
export const SEND_BUTTON_TEXT = "Отправить";
export const REGISTER_BUTTON_TEXT = "Зарегистрироваться";
export const LOGIN_BUTTON_TEXT = "Войти";

// Registra


// PasswordChangeForm

export const  PASSWORD_CHANGE_TEXT = "Изменение пароля";

declare global {
    interface Window {
        TERMS_AND_CONDITIONS: string;
        DATA_POLICY: string;
        CONTACT_EMAIL: string;
        CONTACT_PHONE: string;
    }
}


// Получение переменных из backend
export const TERMS_AND_CONDITIONS = window.TERMS_AND_CONDITIONS;
export const DATA_POLICY = window.DATA_POLICY;
export const CONTACT_EMAIL = window.CONTACT_EMAIL;
export const CONTACT_PHONE = window.CONTACT_PHONE;

